import React, { useEffect, useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import "../../assets/css/global/new_left_side/new_left_side.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faInfoCircle, faCog, faClose, faBars, faArrowDown, faAngleDown, faAngleUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Button, Dropdown } from 'react-bootstrap';
import logo from "../../assets/images/sidebar/logo.png";
import logoSmall from "../../assets/images/sidebar/icon.png";
import ArfsmManual from '../../assets/Manual-RFS-Monitor-Airline.pdf'
import AsrmManual from '../../assets/Manual-Service-Recovery-English.pdf'

import { ReactComponent as HomeIcon } from "../../assets/images/sidebar/home.svg";
import { ReactComponent as HelpIcon } from "../../assets/images/sidebar/help.svg";
import { ReactComponent as LogoutIcon } from "../../assets/images/sidebar/logout.svg";


import Superdashboard from '../../assets/images/superadmin/superdashboard.svg';
import Superorganisation from '../../assets/images/superadmin/superorganisation.svg';
import Supersuperticket from '../../assets/images/superadmin/supersuperticket.svg';
import Supermoduleupdate from '../../assets/images/superadmin/supermoduleupdate.svg';
import Superallstation from '../../assets/images/superadmin/superallstation.svg';
import { toast } from "react-toastify";

// import { useLocation } from "react-router-dom";
import { useAuth, useAuthRFS, useAuthULD, useAuthASR, useAuthHRFS, useAuthSAdmin, useAuthHSPL, useAuthHSR, } from '../../useAuth/useAuth';
import { Logout } from "../common/CommonFunctions";

const LeftMenu = ({ userInfo, onNav, onSubNav, onRtNav, isIconClosed, navs, selTab, onAdd }) => {
    const initialTab = localStorage.getItem('MainTab');
    const initialSub = localStorage.getItem('SubTab');
    const orgLogo = localStorage.getItem('orgLogo');
    const history = useHistory();

    const [selectedTab, setSelectedTab] = useState(selTab);
    const [selectedSub, setSelectedSub] = useState(onSubNav);
    const [subToggle, setSubToggle] = useState(false);
    const [openSubMenu, setOpenSubMenu] = useState(null);

    const navItemsBtm = [
        { path: 'HL', name: 'Help', uc: true, icon: <HelpIcon className='menu-icon' /> },
        { path: 'LO', name: 'Logout Account', class: 'logout', icon: <LogoutIcon className="menu-icon" /> }
    ];

    useEffect(() => {
        setSelectedTab(selTab)
    }, [selTab])

    useEffect(() => {
        const checkSub = navs?.main?.find(i => i.path === selTab) || navs?.report?.find(i => i.path === selTab);
        if (checkSub?.sub) {
            setSubToggle(!subToggle);
            setSelectedSub(initialSub)
        }
    }, [])

    const handleMenuChange = (nav) => {
        // if (['IM', 'EX', 'UL', 'ML', 'EXP', 'HL', 'VSR'].includes(nav.path)) {
        if (nav.uc) {
            toast.warning('Page is under construction!');
        } else if (nav.path === 'LO') {
            Logout(true)
        } else if (nav.path === 'ML' && !nav.uc) {
            downloadManual(nav?.dName, nav?.module)
        } else {
            // localStorage.setItem('MainTab', nav.path)
            // console.log('nav',nav);
            if (nav.sub) {
                setOpenSubMenu(prev =>
                    prev === nav.path ? null : nav.path
                );
                // setSubToggle(!subToggle);
                const stab = localStorage.getItem('SubTab');
                if (nav.path !== selectedTab) {
                    const findDefault = nav?.sub?.find(i => i.default)
                    setSelectedSub(findDefault?.path)
                } else {
                    // setSelectedSub(stab)
                }

                // if (!stab) {
                //     const findDefault = nav?.sub?.find(i => i.default)
                //     // console.log('findDefault',findDefault);
                //     setSelectedSub(findDefault?.path)
                // } else {
                //     setSelectedSub(stab)
                // }
            } else {
                localStorage.removeItem('SubTab')
                // setSubToggle(false);
                setOpenSubMenu(null);
            }

            setSelectedTab(nav.path)
            onNav(nav);
        }

        if (nav.sub) {

        }
    }
    const findmanual = {
        RFSMonitor: ArfsmManual,
        ASR: AsrmManual
    }
    const downloadManual = (name, module) => {
        // e.preventDefault(); // Prevent the default link behavior
        // const pdfUrl = '/Manual-ULD-Test.pdf'; // Path from the public directory
        const a = document.createElement('a');
        a.href = findmanual[module];
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const subMenuChange = (snav) => {
        setSelectedSub(snav.path)
        // localStorage.setItem('SubTab', snav.path)
        // console.log('snav',snav);
        if (isIconClosed) {
            setOpenSubMenu(null)
        }
        onSubNav(snav);
    }
    const handleDashboard = (e) => {
        localStorage.removeItem('extraHeader')
        e.preventDefault();
        const tokenTypes = ['ULD', 'RFS', 'ASR', 'SPL', 'FTM', 'TKM', 'DVR', 'QMS', 'QUT'];
        for (let type of tokenTypes) {
            const tokenValue = localStorage.getItem(type);
            if (tokenValue) {
                localStorage.setItem('airlinetoken', tokenValue);
                localStorage.removeItem(type);
                // history.push('/Dashboard')
                // setRedirecting(true);
            }
            window.location.replace('/Dashboard');
        }
    }

    return (
        <>

            {/* <nav className="sidebar sidebar-offcanvas for_super spr-left" id="sidebar"> */}
            {/* <div className="hmenu">
                <button className="navbar-toggler navbar-toggler align-self-center" type="button" onClick={handleIconClick}>
                    <FontAwesomeIcon icon={isSidebarIconOnly ? faClose : faBars} />
                </button>
            </div> */}

            <aside className="layout sidebar">

                <div className="logo">
                    <img className={isIconClosed ? 'logoSmall' : ''} src={userInfo?.org_logo} alt="logo" />
                </div>

                <nav className="menu">
                    <ul style={{ listStyle: "none", margin: 0 }}>

                        {navs?.button && !navs?.button?.sub &&
                            <li className={`menu-item ${navs?.home && 'home_gap'}`}>
                                <Button className={`${navs?.button.cls} apply_btn_active mt-1`} onClick={() => onAdd()}>
                                    <FontAwesomeIcon icon={faAdd} />
                                    {!isIconClosed && <>{navs?.button.name}</>}
                                </Button>
                            </li>
                        }
                        {navs?.button && navs?.button?.sub &&
                            <Dropdown>
                                <Dropdown.Toggle variant="link" id="dropdown-basic">
                                    <FontAwesomeIcon icon={faAdd} /> {!isIconClosed && <>{navs?.button.name}</>} <FontAwesomeIcon icon={faChevronDown} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {navs?.button?.sub?.map((item, index) => (
                                        <Dropdown.Item key={item.value + index} href="#" onClick={() => onAdd(item.value)}>{item.icon} {item.name}</Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        }
                        {navs?.home &&
                            <>
                                <li className="menu-item">
                                    <Link to='#' onClick={handleDashboard}>
                                        {/* <img className="menu-icon" src={homeicon} /> */}
                                        <HomeIcon className="menu-icon" />
                                        {!isIconClosed && <span>Home</span>}
                                    </Link>
                                </li>

                            </>
                            // </ul>
                        }
                        {/* <ul style={{ listStyle: "none", padding: 0, margin: 0 }}> */}
                        {/* MAIN */}
                        <h3 className="menu-title">Main</h3>
                        {navs?.main?.map((item, index) => (
                            <li className='menu-item' key={index}>
                                <Link to="#" className={selectedTab === item.path ? "active" : ''} onClick={() => handleMenuChange(item)}>
                                    {item.icon}
                                    {!isIconClosed && <span>{item.name}</span>}
                                    {/* {selectedTab === item.path && item.sub && <div></div>} */}
                                    {item.sub && <span className="ms-auto side_arrow"><FontAwesomeIcon icon={openSubMenu === item.path ? faAngleUp : faAngleDown} /></span>}
                                </Link>
                                {openSubMenu === item.path && item.sub && // item.path === selectedTab &&
                                    <ul className="subNav">
                                        {item?.sub?.map((snav, index) => (
                                            <li key={`snav_${index}`} className='sub-item'>
                                                <Link to='#' className={selectedSub === snav.path ? "active" : ''} onClick={() => subMenuChange(snav)}>
                                                    <span>{snav.name}</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                }
                            </li>
                        ))}
                        {/* </ul> */}
                        {/* {console.log('subToggle', subToggle)} */}
                        {/* <ul style={{ listStyle: "none", padding: 0, margin: 0 }}> */}
                        {/* REPORTING */}
                        {navs?.report?.length &&
                            <>

                                <h3 className="menu-title">REPORTING</h3>

                                {navs?.report?.map((item, index) => (
                                    <li key={index} className={`${selectedTab === item.path ? "active" : ''} menu-item`}>
                                        <Link to="#" className={selectedTab === item.path ? "active" : ''} onClick={() => handleMenuChange(item)}>
                                            {/* <img className="menu-icon" src={item.icon} /> */}
                                            {item.icon}
                                            {!isIconClosed && <span>{item.name}</span>}
                                            {/* {selectedRt === item.path && item.sub && <div></div>} */}
                                            {item.sub && <span className="ms-auto side_arrow"><FontAwesomeIcon icon={openSubMenu === item.path ? faAngleUp : faAngleDown} /></span>}
                                        </Link>
                                        {openSubMenu === item.path && item.sub &&
                                            <ul className="subNav">
                                                {item?.sub?.map((snav, index) => (
                                                    <li key={`snav_${index}`} className='sub-item'>
                                                        <Link to='#' className={selectedSub === snav.path ? "active" : ''} onClick={() => subMenuChange(snav)}>
                                                            <span>{snav.name}</span>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        }
                                    </li>
                                ))}
                            </>
                        }
                        {navs?.settings?.length &&
                            <>
                                <h3 className="menu-title">Settings</h3>

                                {navs?.settings?.map((item, index) => (
                                    <li key={index} className={`${selectedTab === item.path ? "active" : ''} menu-item`} onClick={() => handleMenuChange(item)}>
                                        <Link
                                            to="#"
                                            className={selectedTab === item.path ? "active" : ""}
                                        // onClick={() => ReportMenuChange(item)}
                                        >

                                            {item.icon}
                                            {!isIconClosed && <span>{item.name}</span>}
                                        </Link>
                                    </li>
                                ))}
                            </>
                        }
                        {/* </ul>

                        {/* <ul style={{ listStyle: "none", padding: 0, margin: 0 }}> */}
                        {/* SETTINGS */}
                        <h3 className="menu-title last mt-auto"></h3>

                        {navItemsBtm?.map((item, index) => (
                            <li className={`${selectedTab === item.path ? "active" : ''} menu-item ${item?.class ?? ''}`} key={index} onClick={() => handleMenuChange(item)}>
                                <Link to="#">
                                    {item.icon}
                                    {!isIconClosed && <span>{item.name}</span>}
                                    {/* {selectedRt === item.path && item.sub && <div></div>} */}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* HELP */}
                {/* <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    <li className="menu-item">
                        <Link to="#" className={selectedTab === navItemsHlp.path ? "active" : ""} onClick={() => handleMenuChange({ path: 'HLP' })}>
                            {navItemsHlp.icon}
                            {!isIconClosed && <span>{navItemsHlp.name}</span>}
                        </Link>
                    </li>
                </ul> */}

                {/* LOGOUT */}
                {/* <div className="logout">
                    <Link to="#" onClick={logOut}>
                        <LogoutIcon className="menu-icon" />
                        {!isIconClosed && <span>Logout Account</span>}
                    </Link>
                </div> */}

            </aside>

        </>
    );
}
export default LeftMenu;